module.exports = __webpack_public_path__ + "static/media/dry-aged-2.cbc76a45.jpg";